import request from '@/request'

const part_url = '/message/visit/';


/**
 *更新网站访问量
 * @returns
 */
function addVisitCount() {
  let url = part_url + "addCount";
  return request.get(url, {});
}
/**
 *更新公告访问量
 * @returns
 */
 function addNoticeCount(data) {
  let url = part_url + "addNoticeCount";
  return request.get(url, data)
}
/**
 *更新文章访问量
 * @returns
 */
 function addArticleCount(data) {
  let url = part_url + "addArticleCount";
  return request.get(url, data)
}
export default {
  addVisitCount,
  addNoticeCount,
  addArticleCount
}



// WEBPACK FOOTER //
// ./src/api/visit.js